import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import AgentPlayerService from "services/agentPlayerService";
import PlayerService from "services/playerService";

export const getAllPlayers = createAsyncThunk(
  "agent/player/getAll",
  async (
    { page = 1, firstName = null, lastName = null, limit = 8 },
    { rejectWithValue }
  ) => {
    try {
      const response = await AgentPlayerService.getAll(
        page,
        firstName,
        lastName,
        limit
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getPlayerById = createAsyncThunk(
  "agent/player/getByID",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AgentPlayerService.getPlayerById(id);
      console.log("response : ", response);

      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Initial state
const initialState = {
  players: [],
  player: null,
  loading: false,
  error: null,
  totalPlayers: 0,
  currentPage: 1,
  totalPages: 0,
  fetchLoading: false,
  getProfileLoading: false,
};

// Slice
const agentPlayerSlice = createSlice({
  name: "agentPlayer",
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllPlayers.pending, (state) => {
        state.fetchLoading = true;
        state.error = null;
      })
      .addCase(getAllPlayers.fulfilled, (state, action) => {
        state.fetchLoading = false;
        state.players = action.payload.players;
        state.totalPlayers = action.payload.totalPlayers;
        state.totalPages = action.payload.totalPages;
      })
      .addCase(getAllPlayers.rejected, (state, action) => {
        state.players = [];
        state.fetchLoading = false;
        state.error = action.payload;
      })

      .addCase(getPlayerById.pending, (state) => {
        state.getProfileLoading = true;
        state.error = null;
      })
      .addCase(getPlayerById.fulfilled, (state, action) => {
        state.getProfileLoading = false;
        state.player = action.payload;
      })
      .addCase(getPlayerById.rejected, (state, action) => {
        state.getProfileLoading = false;
        state.error = action.payload;
      });
  },
});
export const { setCurrentPage } = agentPlayerSlice.actions;
export default agentPlayerSlice.reducer;
